import graphql__0936e993bf6e62860d23 from "./__generated__/SignUpMutation.graphql.js";import { commitMutation, graphql } from "react-relay";

import appRelayEnvironment from "../config/AppRelayEnvironment";
import { serializeUserFormValues } from "../components/Utils/serializeUserFormValues";

// Static fields that are always present in the form, allowing us to separate
// those fields from the one created in the admin panel when we serialize our
// form for the mutation
const staticFields = [
  "name",
  "email",
  "password",
  "passwordConfirmation",
  "emailConsent",
  "emailTrackingConsent"
];

const mutation = graphql__0936e993bf6e62860d23;

function signUp(form, onCompleted) {
  const variables = serializeUserFormValues(form, staticFields);

  return commitMutation(appRelayEnvironment, {
    mutation,
    variables,
    onCompleted,
    onError: error => console.error(error)
  });
}

export { signUp };
